<div class="modal-overlay">
  <div class="modal-container">
    <div class="modal-header">
      <div class="title">
        <i class="bi bi-bullseye"></i>
        <span>Choose Quiz Type</span>
      </div>
      <i class="bi bi-x close-icon" (click)="closeDialog()"></i>
    </div>

    <p class="subtitle">
      Select the type of quiz you want to create.
    </p>

    <div class="card-wrapper">

      <div class="card">
        <div class="icon purple">
          <i class="bi bi-shield-check"></i>
        </div>

        <h3>Proctored Assessment</h3>
        <p>Used for exams, hiring tests, or evaluations with monitoring features.</p>

        <ul>
          <li><i class="bi bi-check"></i> Webcam / tab switching monitoring</li>
          <li><i class="bi bi-check"></i> Time-bound</li>
          <li><i class="bi bi-check"></i> Strict rules</li>
        </ul>

        <button class="btn primary" (click)="test()">
          Create Assessment
        </button>
      </div>

      <div class="card">
        <div class="icon green">
          <i class="bi bi-mortarboard"></i>
        </div>

        <h3>Course Quiz</h3>
        <p>Used within courses to check learner understanding.</p>

        <ul>
          <li><i class="bi bi-check"></i> Flexible attempts</li>
          <li><i class="bi bi-check"></i> No proctoring</li>
          <li><i class="bi bi-check"></i> Linked to course modules</li>
        </ul>

        <button class="btn primary" (click)="test2()">
          Create Course Quiz
        </button>
      </div>

    </div>
  </div>
</div>